const headerClass = 'header-container.is-sticky';
function goto() {
  let a = $(this).data('id');
  let height = $('' + a).offset().top - $(headerClass).height() - $('#main-nav').height();
  if ($(this).parents('.seamlessbra-category').data('issticky')) {
    height = height - $(this).height();
  }
  const moreId = $(this).data('moretop');
  console.log('========', moreId);
  if (moreId) {
    height = height - $(`#${moreId}`).height();
  }

  $('html, body').animate(
    {
      scrollTop: height,
    },
    500,
  );
}
function setStickyTop() {
  const top = $(headerClass).height() + $('#main-nav').height();
  $(this)
    .parents('.category_bar')
    .css('top', top + 'px');
  $(this).parents('.category_bar').css('position', 'sticky');
}

$(document).ready(function () {
  $('.seamlessbra-category').on('click', '.category-item', function () {
    goto.call(this);
  });
  $('.seamlessbra-category[data-issticky=true]').on('resize', function () {
    setStickyTop.call(this);
  });

  Array.from($('.seamlessbra-category[data-issticky=true]')).forEach((item, index) => {
    setStickyTop.call(item);
  });
});
